module.exports = __webpack_public_path__ + "line.567f57385ea3dde2c9ae.gif";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/vendors/ng-prime/images/line.gif
// module id = ../../../../../src/assets/vendors/ng-prime/images/line.gif
// module chunks = 2